import React from "react";
import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import styles from "./index.module.scss";
import { Loader } from "../../../../shared/ui/Loader";
import { useAppSelector } from "../../../../shared/store";
import { HintChip } from "../../../../shared/ui/HintChip";
import Verif from "../../../../shared/assets/icons/verif.svg";

export const VerifWaiting = () => {
  const offerData = useAppSelector((state) => state.payment.offer);
  return (
    <div className={styles.screen}>
      <OfferStatusInfo
        link={offerData?.goodLink}
        iconSrc={Verif}
        title="Процесс верификации"
        isBtnVisible={!!offerData?.goodLink}
        subTitle={
          <div className={styles.container}>
            <h4 className={styles.subtitle}>{`Номер заказа ${
              offerData && offerData.humanId
            } `}</h4>
            {!offerData && <Loader />}
          </div>
        }
        description="Если вы загрузили некорректный документ, пожалуйста, обратитесь в тех. поддержку."
        content={
          <HintChip className={styles.hintWrapper}>Проверка уже запущена</HintChip>
        }
      />
      {offerData?.goodLink && (
        <a className={styles.link} href={offerData.goodLink}>
          Вернуться на сайт
        </a>
      )}
    </div>
  );
};
